import { render } from "./Orders.vue?vue&type=template&id=01d7b3ba"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Account/Orders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01d7b3ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01d7b3ba', __exports__)) {
    api.reload('01d7b3ba', __exports__)
  }
  
  module.hot.accept("./Orders.vue?vue&type=template&id=01d7b3ba", () => {
    api.rerender('01d7b3ba', render)
  })

}


export default __exports__